<template>
    <div class="kitchenWap">
        <div class="livingRoomSpace">
            <div class="jianbianq"  :class="{'jianbianh':isbrandConcepttitle}" ref="brandConcepttitle">
            <div class="founder spaceCustomization">
                <div class="yishu marginTX"></div>
                <div class="beijing">休闲空间</div>
                <p v-html="seriesIntroduce.bookcaseSpace"  class="kjjianjie" ></p>            
                <!-- <div class="moreBut">了解更多</div> -->
            </div>
        </div>
        <!-- 调整顺序：简·奢茶室第1位，健身房第2位 -->
        <div class="jianbianq"  :class="{'jianbianh':isNewTeaRoomMx}" ref="newTeaRoomMx">
            <div class="spaceCustomization_img homeDecoration newTeaRoom" ref="newTeaRoom" @mouseenter="newTeaRoomEnter" @mouseleave="newTeaRoomLeave">
                <img :src="'https://www.vifa.cn' + newTeaRoomImage" alt="" v-if="newTeaRoomImage">
                <img src="@/common/image/shuguikj.png" alt="" v-else>
                <div class="dingwei" :class="{'dingweishow':isNewTeaRoomDingwei}">
                    <div class="dingweia" @click="newTeaRoomDingweia">+</div>
                    <div class="dingweib" @click="newTeaRoomDingweib">+</div>
                    <div class="dingweic" @click="newTeaRoomDingweic">+</div>
                </div>
                <div class="dwzhankai" v-show="isNewTeaRoomDwzhankai == index" v-for="(item,index) in newTeaRoomData" :key='index' @click="newTeaRoomDwguanbi">
                    <ul>
                        <li>
                            <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                            <div>{{item.title}}</div>
                            <p>{{item.introduce}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hscttitle">简·奢茶室</div>
            <router-link :to="{path:'/productDtails',query:{title:'简·奢茶室',SpaceActiv:6}}"><div class="moreBut">了解更多</div></router-link>
        </div>

        <div class="jianbianq"  :class="{'jianbianh':isGymMx}" ref="gymMx">
            <div class="spaceCustomization_img homeDecoration gym" ref="gym" @mouseenter="gymEnter" @mouseleave="gymLeave">
                <img :src="'https://www.vifa.cn' + gymImage" alt="" v-if="gymImage">
                <img src="@/common/image/shuguikj.png" alt="" v-else>
                <div class="dingwei" :class="{'dingweishow':isGymDingwei}">
                    <div class="dingweia" @click="gymDingweia">+</div>
                    <div class="dingweib" @click="gymDingweib">+</div>
                </div>
                <div class="dwzhankai" v-show="isGymDwzhankai == index" v-for="(item,index) in gymData" :key='index' @click="gymDwguanbi">
                    <ul>
                        <li>
                            <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                            <div>{{item.title}}</div>
                            <p>{{item.introduce}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hscttitle">健身房</div>
            <router-link :to="{path:'/productDtails',query:{title:'健身房',SpaceActiv:6}}"><div class="moreBut">了解更多</div></router-link>
        </div>
        <div class="jianbianq"  :class="{'jianbianh':issjmx}" ref="sjmx">
            <div class="spaceCustomization_img homeDecoration hsct" ref="homeDecoration" @mouseenter="homeDM" @mouseleave="homeDMout">
                <img src="@/common/image/shuguikj.png" alt="">
                <div class="dingwei" :class="{'dingweishow':isdingwei}">
                    <div class="dingweia" @click="hsctdingweia">+</div>
                    <div class="dingweib" @click="hsctdingweib">+</div>
                </div>
                <div class="dwzhankai" v-show="isdwzhankai == index" v-for="(item,index) in dwzhankaiData" :key='index' @click="dwguanbi">
                    <ul>
                        <li>
                            <img class="cfimg" :src="'https://www.vifa.cn' + item.image">
                            <div>{{item.title}}</div>
                            <p>{{item.introduce}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hscttitle">绒面咖茶室书柜</div>
            <router-link :to="{path:'/productDtails',query:{title:'绒面咖茶室书柜',SpaceActiv:6,ittitle:'Suede coffee tearoom bookcase',entitle:'Libreria da tè in pelle scamosciata'}}"><div class="moreBut">了解更多</div></router-link>
        </div>

        </div>
            
    </div>
</template>

<script>
import { getProductDetails } from "@/api/api";


export default {
  name: 'bookcaseSpace',
  data(){
      return{
        dwzhankaiData:[],
        isdwzhankai:999,
        isdingwei:false,
        // 新增第2个产品区域（简·奢茶室）
        newTeaRoomData:[],
        isNewTeaRoomDwzhankai:999,
        isNewTeaRoomDingwei:false,
        newTeaRoomImage:null,
        // 新增第3个产品区域（健身房）
        gymData:[],
        isGymDwzhankai:999,
        isGymDingwei:false,
        gymImage:null,
        isbrandConcepttitle:false,
        issjmx:false,
        isNewTeaRoomMx:false,
        isGymMx:false,
      }
  },
    components: {
    },
    props:{
        seriesIntroduce: {
        type: String 
        }
    },
    mounted() {
       window.addEventListener("scroll", this.handleScroll);    
       this.isbrandConcepttitle = true    
       this.issjmx = true
       this.getkalajinyanData()
       this.getNewTeaRoomData()
       this.getGymData()
    },
    methods:{
        getkalajinyanData(){
            let data = {
                productName:"绒面咖茶室书柜"
            }
            getProductDetails(data)
            .then(res =>{
                this.dwzhankaiData = res.productSpecific
            })
            .catch(res=>{
                console.log(res)
            })
        },
        getNewTeaRoomData(){
            let data = {
                productName:"简·奢茶室"
            }
            getProductDetails(data)
            .then(res =>{
                this.newTeaRoomData = res.productSpecific
                this.newTeaRoomImage = res.productSeries.image
            })
            .catch(res=>{
                console.log(res)
            })
        },
        getGymData(){
            let data = {
                productName:"健身房"
            }
            getProductDetails(data)
            .then(res =>{
                this.gymData = res.productSpecific
                this.gymImage = res.productSeries.image
            })
            .catch(res=>{
                console.log(res)
            })
        },
        handleScroll(){
            this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
            // if (e.deltaY>0) {
                if (this.$refs.brandConcepttitle.offsetTop > this.scroll +document.documentElement.clientHeight) {
                    this.isbrandConcepttitle = false
                }
                if (this.$refs.sjmx.offsetTop > this.scroll +document.documentElement.clientHeight) {
                    this.issjmx = false
                }
                if (this.$refs.brandConcepttitle.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.isbrandConcepttitle = true
                }
                if (this.$refs.sjmx.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.issjmx = true
                }
                if (this.$refs.newTeaRoomMx && this.$refs.newTeaRoomMx.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.isNewTeaRoomMx = true
                }
                if (this.$refs.gymMx && this.$refs.gymMx.offsetTop < this.scroll +document.documentElement.clientHeight) {
                    this.isGymMx = true
                }

            // }else if (e.deltaY < 0) {
                if (this.$refs.brandConcepttitle.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.isbrandConcepttitle = false
                }
                if (this.$refs.sjmx.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.issjmx = false
                }
                if (this.$refs.newTeaRoomMx && this.$refs.newTeaRoomMx.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.isNewTeaRoomMx = false
                }
                if (this.$refs.gymMx && this.$refs.gymMx.offsetTop > this.scroll +document.documentElement.clientHeight-200) {
                    this.isGymMx = false
                }
            // }
        },
        homeDM(){
            this.isdingwei = true
        },
        homeDMout(){
            this.isdingwei = false
        },
        dwguanbi(){
            this.isdwzhankai = 999
        },
        hsctdingweia(){
            this.isdwzhankai = 0
        },
        hsctdingweib(){
            this.isdwzhankai = 1
        },
        // 简·奢茶室的方法
        newTeaRoomEnter(){
            this.isNewTeaRoomDingwei = true
        },
        newTeaRoomLeave(){
            this.isNewTeaRoomDingwei = false
        },
        newTeaRoomDwguanbi(){
            this.isNewTeaRoomDwzhankai = 999
        },
        newTeaRoomDingweia(){
            this.isNewTeaRoomDwzhankai = 0
        },
        newTeaRoomDingweib(){
            this.isNewTeaRoomDwzhankai = 1
        },
        newTeaRoomDingweic(){
            this.isNewTeaRoomDwzhankai = 2
        },
        // 健身房的方法
        gymEnter(){
            this.isGymDingwei = true
        },
        gymLeave(){
            this.isGymDingwei = false
        },
        gymDwguanbi(){
            this.isGymDwzhankai = 999
        },
        gymDingweia(){
            this.isGymDwzhankai = 0
        },
        gymDingweib(){
            this.isGymDwzhankai = 1
        },
  },
  unmounted(){
    window.removeEventListener("scroll", this.handleScroll);    
    }
}
</script>

<style scoped>
.kitchenWap .spaceCustomization p{
    /* width: 740px; */
    margin: 0 auto;white-space: pre-wrap;
    /* text-align: left; */
}
.hsct .dingwei .dingweia{
left: 22%;
    top: 30.5%;
}
.hsct .dingwei .dingweib{
    left: 23.5%;
    top: 57%;
}
.kitchenWap .dwzhankai ul{
    width: 875px;
    height: 710px;
}
.kitchenWap .dwzhankai ul li .cfimg{
    width: 400px;
    height: 352.5px;
    margin:88px 0 25px 355px;
}
.kitchenWap .dwzhankai ul li div{
    font-size: 30px;
    padding-top: 0;
}
.kitchenWap .dwzhankai ul li p{
    padding-top: 15px;
    font-size: 16px;
}
.hscttitle{
    font-size: 30px;
    text-align: center;
    padding-top: 60px;
    padding-bottom: 60px;
}

/* 简·奢茶室的+号位置（从左到右排列） */
.newTeaRoom .dingwei .dingweia{
    left: 53%;
    top: 66%;
}
.newTeaRoom .dingwei .dingweib{
    left: 50%;
    top: 43%;
}
.newTeaRoom .dingwei .dingweic{
    left: 84%;
    top: 50%;
}

/* 健身房的+号位置 */
.gym .dingwei .dingweia{
    left: 30%;
    top: 50%;
}
.gym .dingwei .dingweib{
    left: 76%;
    top: 50%;
}
</style>
